import React from "react";

export function Skeleton({ width = "100%", height = 18, radius = 6, style = {} }) {
  return (
    <span
      className="skeleton"
      style={{ width, height, borderRadius: radius, display: "block", ...style }}
    />
  );
}

export function SkeletonRow({ cols = 5, colWidths }) {
  return (
    <div
      className="table-row skeleton-row"
      style={{ gridTemplateColumns: colWidths || `repeat(${cols}, 1fr)` }}
    >
      {Array.from({ length: cols }).map((_, i) => (
        <span key={i} style={{ padding: "18px 24px" }}>
          <Skeleton height={14} width={i === 0 ? "70%" : i % 2 === 0 ? "55%" : "80%"} />
        </span>
      ))}
    </div>
  );
}

export function SkeletonCard({ lines = 3 }) {
  return (
    <div className="skeleton-card">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height={i === 0 ? 16 : 13} width={i === 0 ? "60%" : i % 2 === 0 ? "40%" : "80%"} style={{ marginBottom: 10 }} />
      ))}
    </div>
  );
}

export function SkeletonStat() {
  return (
    <div className="stat-card skeleton-stat">
      <span className="skeleton" style={{ width: 40, height: 40, borderRadius: 6 }} />
      <div style={{ flex: 1, display: "grid", gap: 8 }}>
        <Skeleton height={11} width="55%" />
        <Skeleton height={22} width="70%" />
      </div>
    </div>
  );
}
